import { User } from 'apis/restaurant-api/merchant-admin/user/types';
import { localize } from 'common/utils';

export type IntercomUser = {
  user_id: string;
  name: string;
  first_name: string;
  last_name: string;
  country: string;
  email: string;
  user_hash: string;
};

const Intercom = (...args: any[]) => {
  if (canUseDOM && localWindow.Intercom) {
    localWindow.Intercom.apply(null, args);
  } else {
    console.warn('Intercom not initialized yet');
  }
};

export const localWindow = window as any;

export const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

export const IntercomAPI = {
  show: () => {
    Intercom('show');
  },
  showMessages: () => {
    Intercom('showMessages');
  },
  showNewMessage: (initialMessage?: string) => {
    Intercom('showNewMessage', initialMessage);
  },
} as const;

export const getIntercomUserName = () => {
  return localWindow.intercomSettings ? localWindow.intercomSettings.name : '';
};

export const updateIntercomUserName = (name: string) => {
  if (!localWindow.intercomSettings) {
    return;
  }

  localWindow.intercomSettings.name = name;
  localWindow.Intercom('update', { name });
};

export const createUserForIntercom = (user: User): IntercomUser => {
  const firstName = user.name?.first_name || '';
  const lastName = user.name?.last_name || '';

  return {
    user_id: user._id.$oid,
    name: `${firstName} ${lastName}`,
    email: user.email,
    first_name: firstName,
    last_name: lastName,
    country: user.country,
    user_hash: user.intercom_user_hash,
  };
};

export const getIntercomUserNameWithMerchant = (merchantName: Localized): string => {
  const formattedMerchantName = merchantName ? localize(merchantName, '') : 'No Merchant Identified';

  return `${getIntercomUserName()} (${formattedMerchantName})`;
};
